import simpleParallax from "simple-parallax-js";
import {waitLoad} from '../utilities/load';
import {TemplateConstant} from "../../../../../../resources/js/templateConstant";

const DEFAULT_PARAMS = {
    selector: '.cta-parallax-img'
}

export class CtaParallax {
    constructor(params = {}) {
        const templateValue = new TemplateConstant();
        if (!templateValue.hasNoParallax) {
            this.currentParallaxSettings = 0;
            this.allParallax = [];
            const that = this;
            this.params = Object.assign({}, DEFAULT_PARAMS, params);
            this.ctaParallaxImg = document.querySelectorAll(this.params.selector);
            if (this.ctaParallaxImg) {
                for (let x = 0; x < that.ctaParallaxImg.length; x++) {
                    const currentCta = that.ctaParallaxImg[x].parentElement.parentElement.parentElement.parentElement;
                    const mobileColor = currentCta.getAttribute('data-text-color-mobile');
                    const hoverColor = currentCta.getAttribute('data-text-color-hover');
                    const backgroundHoverColor = currentCta.getAttribute('data-background-color-hover');
                    const btnMobileColor = currentCta.getAttribute('data-btn-color-mobile');
                    const btnMobileBackgroundColor = currentCta.getAttribute('data-btn-background-mobile');
                    const btnColor = currentCta.getAttribute('data-btn-color');
                    const textColor = currentCta.getAttribute('data-text-color');
                    const linkElement = currentCta.querySelector('a');

                    that.setupParallax(that.ctaParallaxImg[x]);
                    if (window.innerWidth > 768) {
                        that.setupDesktopColors(currentCta, linkElement, textColor, btnColor, btnMobileBackgroundColor)
                        that.setupHoverColors(linkElement, hoverColor, backgroundHoverColor, btnColor);
                    } else {
                        that.setupMobileColors(currentCta, linkElement, mobileColor, btnMobileColor, btnMobileBackgroundColor)
                    }
                }
                that.isMobile = (window.innerWidth < 768);
                window.addEventListener('resize', that.checkOnResize);
            }
        }
    }

    checkOnResize = () => {
        if (this.isMobile && window.innerWidth > 768) {
            this.isMobile = false;
            for (let x = 0; x < this.ctaParallaxImg.length; x++) {
                const currentCta = this.ctaParallaxImg[x].parentElement.parentElement.parentElement.parentElement.parentElement;
                const linkElement = currentCta.querySelector('a');
                const textColor = currentCta.getAttribute('data-text-color');
                const btnColor = currentCta.getAttribute('data-btn-color');
                const hoverColor = currentCta.getAttribute('data-text-color-hover');
                const backgroundHoverColor = currentCta.getAttribute('data-background-color-hover');
                const btnMobileBackgroundColor = currentCta.getAttribute('data-btn-background-mobile');

                this.resetColors(currentCta, linkElement);

                this.setupDesktopColors(currentCta, linkElement, textColor, btnColor, btnMobileBackgroundColor)
                this.setupHoverColors(linkElement, hoverColor, backgroundHoverColor, btnColor);
            }
        } else if (!this.isMobile && window.innerWidth < 768) {
            this.isMobile = true;
            for (let x = 0; x < this.ctaParallaxImg.length; x++) {
                const currentCta = this.ctaParallaxImg[x].parentElement.parentElement.parentElement.parentElement.parentElement;
                const linkElement = currentCta.querySelector('a');
                const mobileColor = currentCta.getAttribute('data-text-color-mobile');
                const btnMobileColor = currentCta.getAttribute('data-btn-color-mobile');
                const btnMobileBackgroundColor = currentCta.getAttribute('data-btn-background-mobile');

                this.resetColors(currentCta, linkElement);

                this.setupMobileColors(currentCta, linkElement, mobileColor, btnMobileColor, btnMobileBackgroundColor)
            }
        }
        if (window.innerWidth > 1500 && this.currentParallaxSettings != 3) {
            for (let x = 0; x < this.ctaParallaxImg.length; x++) {
                this.setupParallax(this.ctaParallaxImg[x]);
            }
        } else if (window.innerWidth > 1200 && this.currentParallaxSettings != 2) {
            for (let x = 0; x < this.ctaParallaxImg.length; x++) {
                this.setupParallax(this.ctaParallaxImg[x]);
            }
        } else if (window.innerWidth > 768 && this.currentParallaxSettings != 1) {
            for (let x = 0; x < this.ctaParallaxImg.length; x++) {
                this.setupParallax(this.ctaParallaxImg[x]);
            }
        }
    }
    setupParallax = (elem) => {
        let isNewParallax = true;
        let curParallax;
        let speed = Math.random();
        let isNegative = Math.floor(Math.random() * 10) + 1;
        let reverse = 'up';
        if (isNegative > 5) {
            reverse = 'down'
        }
        for (let x = 0; x < this.allParallax.length; x++) {
            if (this.allParallax[x].element == elem) {
                isNewParallax = false;
                window.setTimeout(() => {
                    if (this.allParallax[x].parallax) {
                        if (window.innerWidth > 1500) {
                            this.currentParallaxSettings = 3;
                            this.allParallax[x].parallax.settings = {
                                delay: speed,
                                transition: 'cubic-bezier(0,0,0,1)',
                                orientation: reverse,
                                maxTransition: 50,
                                scale: 1.3
                            };
                        } else if (window.innerWidth > 1200) {
                            this.currentParallaxSettings = 2;
                            this.allParallax[x].parallax.settings = {
                                delay: speed,
                                transition: 'cubic-bezier(0,0,0,1)',
                                orientation: reverse,
                                maxTransition: 30,
                                scale: 1.7
                            };
                        } else if (window.innerWidth > 768) {
                            this.currentParallaxSettings = 1;
                            this.allParallax[x].parallax.settings = {
                                transition: 'linear',
                                maxTransition: 1,
                                scale: 1.3,
                            };
                        }
                    }
                }, 10)
            }
        }
        if (isNewParallax) {
            if (window.innerWidth > 1500) {
                this.currentParallaxSettings = 3;
                curParallax = new simpleParallax(elem, {
                    delay: speed,
                    transition: 'cubic-bezier(0,0,0,1)',
                    orientation: reverse,
                    maxTransition: 50,
                    scale: 1.3
                });
            } else if (window.innerWidth > 1200) {
                this.currentParallaxSettings = 2;
                curParallax = new simpleParallax(elem, {
                    delay: speed,
                    transition: 'cubic-bezier(0,0,0,1)',
                    orientation: reverse,
                    maxTransition: 30,
                    scale: 1.7
                });
            } else if (window.innerWidth > 768) {
                this.currentParallaxSettings = 1;
                curParallax = new simpleParallax(elem, {
                    transition: 'linear',
                    maxTransition: 1,
                    scale: 1.3,
                });
            }
            this.allParallax.push(
                {
                    element: elem,
                    parallax: curParallax
                }
            )
        }
    }
    setupDesktopColors = (currentCta, linkElement, textColor, btnColor, btnMobileBackgroundColor) => {
        if (btnColor != "#") {
            linkElement.style.color = btnColor;
            linkElement.style.borderColor = btnColor;
        }
        if (textColor != "#") {
            currentCta.querySelector('h2').style.color = textColor;
            currentCta.querySelector('p').style.color = textColor;
        }
        if (linkElement.querySelector('span').style.background == btnMobileBackgroundColor) {
            linkElement.querySelector('span').style.background == '';
        }
    }
    setupMobileColors = (currentCta, linkElement, mobileColor, btnMobileColor, btnMobileBackgroundColor) => {
        if (mobileColor != "#") {
            currentCta.querySelector('h2').style.color = mobileColor;
            currentCta.querySelector('p').style.color = mobileColor;
        }
        if (btnMobileColor != "#") {
            linkElement.style.color = btnMobileColor;
            linkElement.style.borderColor = btnMobileColor;
        }
        if (btnMobileBackgroundColor != "#") {
            linkElement.style.background = btnMobileBackgroundColor;
        }
    }
    setupHoverColors = (linkElement, hoverColor, backgroundHoverColor, btnColor) => {
        if (hoverColor != '#') {
            if (linkElement) {
                linkElement.addEventListener('mouseenter', () => {
                    linkElement.style.color = hoverColor;
                    linkElement.style.borderColor = hoverColor;
                    linkElement.querySelector('span').style.background = backgroundHoverColor;
                });
                linkElement.addEventListener('mouseleave', () => {
                    linkElement.style.color = btnColor;
                    linkElement.style.borderColor = btnColor;
                    linkElement.querySelector('span').style.background = '';
                });
            }
        } else {
            if (linkElement) {
                linkElement.addEventListener('mouseenter', () => {
                    linkElement.style.color = '';
                    linkElement.style.borderColor = '';
                });
                if (btnColor) {
                    linkElement.addEventListener('mouseleave', () => {
                        linkElement.style.color = btnColor;
                        linkElement.style.borderColor = btnColor;
                    });
                }
            }
        }
    }
    resetColors = (currentCta, linkElement) => {
        if (linkElement) {
            linkElement.style.color = '';
            linkElement.style.borderColor = '';
            linkElement.querySelector('span').style.background = '';
            linkElement.style.background = '';
        }
        if (currentCta) {
            currentCta.querySelector('h2').style.color = '';
            currentCta.querySelector('p').style.color = '';
        }
    }
}
